import http from '../http-common';

class RolesDataService {
  getAll(params = '') {
    return http.get(`/roles${params || ''}`);
  }

  get(id) {
    return http.get(`/roles/${id}`);
  }

  create(data) {
    return http.post("/roles/add", data);
  }

  update(id, data) {
    return http.put(`/roles/update/${id}`, data);
  }

  
  delete(id) {
    return http.put(`/roles/delete/${id}`);
  }
}

export default new RolesDataService();
